var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "tw-flex tw-flex-col tw-shadow-xs tw-bg-white tw-rounded-md tw-overflow-hidden"
    },
    [
      _c(
        "div",
        { staticClass: "tw-flex tw-justify-center tw-bg-gray-500 tw-p-3" },
        [
          _c(
            "span",
            { staticClass: "tw-text-white tw-uppercase tw-font-semibold" },
            [_vm._v(" " + _vm._s(_vm.display_name) + " ")]
          )
        ]
      ),
      _vm.motmTable.length
        ? _c(
            "div",
            { staticClass: "tw-flex tw-flex-col tw-px-4 tw-py-3" },
            [
              _vm._m(0),
              _vm._l(_vm.motmTable, function(player, playerIndex) {
                return _c(
                  "div",
                  {
                    key: "motom-row-" + playerIndex,
                    staticClass: "tw-flex tw-pb-2"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "tw-flex tw-font-semibold",
                        staticStyle: { width: "5%" }
                      },
                      [_vm._v(" " + _vm._s(playerIndex + 1) + " ")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "tw-flex tw-pr-2",
                        staticStyle: { width: "45%" }
                      },
                      [_c("span", [_vm._v(_vm._s(player.name))])]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "tw-flex tw-pr-2",
                        staticStyle: { width: "45%" }
                      },
                      [_c("span", [_vm._v(_vm._s(player.team))])]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "tw-flex tw-justify-center",
                        staticStyle: { width: "5%" }
                      },
                      [_vm._v(" " + _vm._s(player.awards) + " ")]
                    )
                  ]
                )
              })
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "tw-flex tw-justify-center tw-px-4 tw-py-3" },
            [
              _c("span", { staticClass: "tw-text-gray-700" }, [
                _vm._v("No POTM awards to show yet")
              ])
            ]
          )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tw-flex tw-pb-3 tw-font-semibold" }, [
      _c("div", { staticClass: "tw-flex", staticStyle: { width: "5%" } }),
      _c("div", { staticClass: "tw-flex", staticStyle: { width: "45%" } }, [
        _c("span", [_vm._v("Name")])
      ]),
      _c("div", { staticClass: "tw-flex", staticStyle: { width: "45%" } }, [
        _c("span", [_vm._v("Team")])
      ]),
      _c(
        "div",
        {
          staticClass: "tw-flex tw-justify-center",
          staticStyle: { width: "5%" }
        },
        [_vm._v("🏆")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }